<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Báo cáo tra cứu</strong>
                    </div>
                    <b-list-group>
                        <b-list-group-item v-for="(item, index) in lookupReports" :key="item.id">
                            <router-link :to="{ path: `/view-reports/lookup/${item.path}` }">
                                {{ index + 1 + ". " + item.text }}
                            </router-link>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    export default {
        name: 'ListReport',
        data() {
            return {
                lookupReports: [
                    { id: 1, text: 'Báo cáo tổng hợp tình hình quản lý, sử dụng tài sản công', path: 'BCTC_01' },
                    { id: 2, text: 'Báo cáo tổng hợp tình hình tăng, giảm tài sản công', path: 'BCTC_02' },
                    { id: 3, text: 'Báo cáo tổng hợp tình hình tăng tài sản công', path: 'BCTC_03' },
                    { id: 4, text: 'Báo cáo tổng hợp tình hình giảm tài sản công', path: 'BCTC_04' }]
            }
        },
        computed: {

        },
        created() {
        },
        methods: {

        }
    }
</script>
<style scoped>
</style>
